import { createRouter, createWebHashHistory } from "vue-router"

/**
 * 路由配置
 * 使用懒加载方式引入组件以提高性能
 */

// 视图组件懒加载
const index = () => import("@/views/Series.vue")

// 路由配置
const routes = [
  { 
    path: "/", 
    redirect: "/index" 
  },
  {
    path: "/index",
    name: "index",
    component: index,
    meta: {
      title: "首页"
    }
  },
  {
    path: "/sampleInOut",
    name: "sampleInOut",
    component: () => import("@/views/sampleInOut.vue"),
    meta: {
      title: "样衣入/出库"
    }
  },
  {
    path: "/traceability",
    name: "traceability",
    component: () => import("@/views/Traceability.vue"),
    meta: {
      title: "商品溯源"
    }
  },

]

// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 全局后置钩子
router.afterEach((to) => {
  let title = to.params.title ? to.params.title : ''
  
  if (to.meta && to.meta.title) {
    if (title !== '') {
      title += ' - ' + to.meta.title
    } else {
      title = to.meta.title
    }
  }

  // 设置文档标题
  document.title = title !== '' ? title : '马骑顿'
})

export default router
